import { useEffect } from 'react'
import { useOrganization } from '../contexts/OrganizationContext'
import { useMessagingUnreadCount } from '../hooks/useFloatingMessaging'

// Au-delà, le compteur devient illisible dans un onglet étroit et n'apporte
// plus d'information : « beaucoup » suffit.
const MAX_DISPLAYED = 99

/**
 * Écrivain UNIQUE de `document.title`.
 *
 * Affiche le nombre de messages non lus en tête du titre de l'onglet
 * (« (3) Aveyron Worldwide | Terrilink »), seul signal visible quand
 * l'application tourne dans un onglet d'arrière-plan : la pastille du dock est
 * hors champ et la notification navigateur suppose une permission accordée.
 *
 * Pourquoi un seul écrivain : OrganizationContext posait aussi le titre. Deux
 * sources sur la même propriété, et c'est la dernière qui gagne — or les effets
 * d'un parent s'exécutent APRÈS ceux de ses enfants, donc le contexte aurait
 * systématiquement effacé le compteur au chargement de l'organisation. Le
 * contexte ne gère plus que les balises Open Graph.
 *
 * Le compteur vient de la source canonique de la messagerie
 * (`useMessagingUnreadCount`), la même que la pastille du dock : titre et
 * pastille ne peuvent donc pas diverger. Surtout PAS `state.messages`, qui
 * malgré son nom porte le compteur de la CLOCHE — `SocketContext` y route
 * `unread_notification_count`, soit toutes les notifications, tous types
 * confondus. Le titre y aurait annoncé « (12) » à quelqu'un sans un seul
 * message non lu.
 */
const DocumentTitle = () => {
  const totalUnread = useMessagingUnreadCount()
  const { config } = useOrganization()
  const organizationName = config?.name?.trim()

  useEffect(() => {
    const base =
      !organizationName || organizationName === 'Terrilink'
        ? 'Terrilink'
        : `${organizationName} | Terrilink`

    if (totalUnread > 0) {
      const shown = totalUnread > MAX_DISPLAYED ? `${MAX_DISPLAYED}+` : totalUnread
      document.title = `(${shown}) ${base}`
    } else {
      document.title = base
    }
  }, [organizationName, totalUnread])

  return null
}

export default DocumentTitle
